let globalStrings = {
  multipassToken: "2759d307aab2450cb0f4fda4a6a18a05",
  navigationMenu: [
    {
      name: "Overview",
      path: "overview",
      data: "recharge-internal-view-your-next-order"
    },
    {
      name: "Upcoming",
      path: "schedule",
      data: "recharge-internal-view-upcoming-orders"
    },
    {
      name: "History",
      path: "/account?view=orders",
      isShopify: true,
      data: "recharge-internal-address-order-history"
    },
    {
      name: "Popstar Rewards",
      path: "credits",
      isShopify: true,
      data: "recharge-internal-rewards"
    },
    // {
    //     name: "SMS Preferences",
    //     path: "sms-preferences",
    //     isShopify: true,
    //     data: "recharge-internal-sms-preferences"
    // },
    {
      name: "Subscriptions",
      path: "subscriptions",
      data: "recharge-internal-manage-subscriptions"
    },
    {
      name: "Address & Payment",
      path: "customer",
      data: "recharge-internal-address-&-payment-details"
    },
    {
      name: "Logout",
      path: "logout",
      data: "recharge-internal-logout"
    }
  ]
}
$(document).ready(async function () {
  const page = window.location.href
  if (page.includes('/tools/recurring/portal/')) {
    setTimeout(() => {
      initilizeAffinityApp()
    }, 500);
  }
  document.addEventListener('customLoginDone', (e) => {
    console.log('custom Login Event done', e)
  })

  initializeRechargeSDK()

  if(window.location.href.includes('/tools/recurring/portal/')) {
    // Initialize Custom  mobile Naviation Menu
    initializeMobileNavigationMenu();

  }


  /**
    * Affinity Event that trigger When Recharge Slot Mounted
    */
  document.addEventListener("Recharge::slot::mounted", async (event) => {
    console.log('Recharge::slot::mounted', event)
    const { name } = event.detail;

    if (name === 'header') {
      // Initialize Custom  mobile Naviation Menu
      // initializeMobileNavigationMenu();
    }

    if (isCreditPage(event.detail.pathname)) {
      creditSlotHandler.handleCreditPage(event, true)
    }

    $('#recharge-customer-portal').removeClass('creditHeaderSlot');

  })




  /**
     * Affinity Event that trigger When Recharge Location Change 
     */
  document.addEventListener("Recharge::location::change", (event) => {
    // Handle Show Credit 
    if (isCreditPage(event.detail.pathname) && window?.creditSlotHandler) {
      creditSlotHandler.handleCreditPage(event)
    }

    if (!isCreditPage(event.detail.pathname)) {
      creditSlotHandler.deintializeCreditPage()
    }

  });

  $(document).on('click', '#customLoginButtonRecharge', (e) => {
    localStorage.setItem('loggin_from_shopify', true)
  })

  // check if user logged in from shopify redirect them to portal directly
  const isloggedInFromShopify = localStorage.getItem('loggin_from_shopify');
  if (isloggedInFromShopify) {
    $('.redirectMessage').show();
    const sessionRecharge = await initializeRechargeSDK();
    const customerDetails = await getCustomerDetails(sessionRecharge);

    console.log(customerDetails);
    if (customerDetails) {
      const url = `${customerDetails.base_url}${customerDetails.customer_hash}/overview?token=${customerDetails.temp_token}`;
      localStorage.removeItem('loggin_from_shopify');
      window.location.href = url

      console.log(url);
      setTimeout(() => {
        $('.redirectMessage').hide();
      }, 3000);
    }
  } else {
    $('.redirectMessage').hide();
  }


  $(document).on('click', '.tabsCustom label', function () {
    var $navContainer = $("#custom-navigation-dropdown");
    var $slider = $(".slider");
    updateSlider($(this), $navContainer, $slider);
    const selectedNavigation = $(this).attr('data-path')
    handleAfterchangeCustomNavigationSelector(selectedNavigation)
  })

})

/**
 * Function for get customer details
 */
const getCustomerDetails = async (sessionRecharge = false) => {
  try {
    return await recharge.customer.getCustomerPortalAccess(sessionRecharge)
  } catch (error) {
    console.log('errors', error)
  }
}


const initializeRechargeSDK = async () => {
  recharge.init({
    storeIdentifier: 'popstarlabs.myshopify.com',
    storefrontAccessToken: 'strfnt_bf6752d132ce217245de26deb46abfafa56cf861acf9b06eec54fa3ca2119d89'
  });

  try {
    const sessionRecharge = await recharge.auth.loginShopifyAppProxy();
    window.sessionRecharge = sessionRecharge;
    setTimeout(() => {
      // dispatch event customer logged in done
      const customerLoggedInEvent = new CustomEvent("customerRechargeLoggedIn", {
        detail: {
          sessionRecharge,
        },
      });
      document.dispatchEvent(customerLoggedInEvent);
    }, 500);
    return sessionRecharge
  } catch (error) {
    console.error('Error logging in:', error);
  }
}


const handleCreditSloProgramName = (customer = false) => {
  // if (window.innerWidth > 768) return
  if (ReCharge?.customer?.tags || customer?.tags) {
    const customerTags = ReCharge.customer.tags || customer.tags
    const programName = customerTags.find(item => item.includes('rc-member'))
      ? customerTags.find(item => item.includes('rc-member') && !item.includes('inactive')).split('-')[2]
      : false;
    const colors = {
      vip: "#FAEB37",
      icon: "#FF00E4"
    };
    const backgroundColor = colors[programName];
    if (programName) {
      return `<span class="previewTextProgramName" style="height: 34px;border-radius: 4px;color: #2b2b2b;font-size: 14px;font-weight: 700;text-transform: uppercase;padding: 4px 6px;display: flex;justify-content: center;align-items: center;margin-bottom: 10px;;background-color:${backgroundColor}"> ${programName}</span>`;
    } else return false;
  }

}

/**
 * Function for apply custom navigation 
 */
const initializeMobileNavigationMenu = async () => {
  console.log('initializeMobileNavigationMenu here >>>>>>>>')
  const navigationHtml = await getCustomNaviationMenuHtml();
  console.log($('#custom-mobile-navigation-wrapper'));
  $('#custom-mobile-navigation-wrapper').html(navigationHtml);
  // Call the jQuery function after the menu is rendered
  initSlidingBorderEffect();
}


const initilizeAffinityApp = async () => {
  if (ReCharge) {
    // Initiliaze multipass
    await autoLoginShopify()

    // Append Order history Page
    handleOrderHistoryMenu()

    // Append Rewards Page
    handleRewardsMenu()
  }
}

/**
 * Function for get custom navigation menu
 */
const getCustomNaviationMenuHtml = async () => {
  const firstName = ReCharge?.customer?.first_name;
  if (!firstName) {
    return;
  }
  if (!ReCharge?.subscriptions) return;
  const oldestSubscription = findOldestSubscription(ReCharge.subscriptions);
  if (!oldestSubscription || !oldestSubscription.created_at) {
    return;
  }
  // Get today +1 date
  const memberSinse = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(new Date(oldestSubscription.created_at))
  if (!oldestSubscription && !memberSinse) {
    return;
  }
  const navigationMenuDropdown = getNavigationDropDownHtml();
  const creditAmount = await getCreditAmount();

  const programName = handleCreditSloProgramName()
  return `
  <div class="customMobileNavigation">
       <div class="memberAndRewardContianer" style="display: flex;width: 100%;justify-content: space-between;align-items: center;">
         <h3 class="previewText" style="position: relative">Hi, ${firstName} </h3>
         ${programName ? programName : ''}
      </div>
      <div class="memberAndRewardContianer" style="display: flex;width: 100%;justify-content: space-between;align-items: center;">
        <p class="previewContent">Member since ${memberSinse}</p>
        ${creditAmount ? `<p class="previewContent">Rewards: $${creditAmount}</p>` : ''}
      </div>
  </div>
  <div class="customNavigationMenuDropdown">
      ${navigationMenuDropdown}
  </div>
  `
}

/**
 * Handles the rewards menu in the UI by asynchronously fetching and inserting the rewards menu HTML content.
 * This function fetches the HTML content of the rewards menu asynchronously using the getRewardsMenuHtml function
 * and inserts it after the parent element of the custom order history menu button.
 * 
 * @returns {void}
 */
const handleRewardsMenu = async () => {
  try {
    // Fetch the rewards menu HTML content asynchronously
    const orderHistoryMenu = await getRewardsMenuHtml();

    // Insert the rewards menu HTML content after the parent element of the custom order history menu button
    $('#customOrderHistoryMenuButton').parent().after(orderHistoryMenu)
  } catch (error) {
    // Handle any errors that occur during the process
    console.error('Error updating rewards menu:', error);
    // Optionally, perform error handling such as displaying a user-friendly message
    // or logging the error for further investigation
  }
}

/**
 * Function for get url params by key
 */
const getUrlParamsByKey = (key) => {
  // Assuming the URL is stored in a variable called 'url'
  const urlParams = new URLSearchParams(window.location.search);

  // Get the value of a specific parameter
  const value = urlParams.get(key);

  return value;
}


/**
 * Fucntion for check its overview page or not
 * @param pathname 
 * @returns {Promise<boolean>}
 */
const isCreditPage = (pathname) => {
  // Check if the pathname contains "/subscriptions/"
  return pathname.includes("/credits");
}



/**
 * Get Rewards menu html
 * @returns  {Promise<string>}
 */
const getRewardsMenuHtml = async () => {
  const token = getUrlParamsByKey('token');
  const url = `/tools/recurring/portal/${ReCharge.customer.hash}/credits?token=${token}`
  return `
  <a
  data-testid="recharge-internal-rewards"
  data-active="true"
  class=""
  id="customRewardsMenuButton"
  href="${url}"
>
  <div class="">
    <div class="recharge-card sideBarMenuLink">
      <div class="sideBarMenuWrap">
        <span
          role="heading"
          aria-level="2"
          class="recharge-heading recharge-heading-h2 affinityLinkText"
          >Popstar Rewards</span
        >
        <div class="" style="padding:0 6px;">
          <div class="rechargeColor">
            <div class="recharge-icon">
              <svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <path d="m1.5 15 7-7-7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>`
}


const getCreditAmount = async () => {
  const sessionRecharge = await recharge.auth.loginCustomerPortal();
  const creditSummary = await recharge.customer.getCreditSummary(sessionRecharge, {
    include: ['credit_details'],
  });

  if (!creditSummary && !creditSummary?.customer_id) {
    console.log('Problem with getting customer id from recharge sdk');
    return;
  }

  const totalBalance = creditSummary?.total_available_balance;

  return totalBalance
}


const getNavigationDropDownHtml = () => {
  const html = getNavigationOptionHtml()
  return `
  <div id="custom-navigation-dropdown">
      ${html}
  </div>
`;
}

const getNavigationOptionHtml = () => {
  const currentUrl = window.location.href;
  return globalStrings.navigationMenu.map((item, index) => {
    return `<div class="tabsCustom ${currentUrl.includes(item.path) ? 'active' : ''}">
      <label data-index="${index}" for="${item.path}" data-path="${item.data}">
       <input type="radio" name="tab_navigation" id="${item.path}" ${currentUrl.includes(item.path) ? 'checked' : ''} >
        ${item.name}
      </label>
    </div>`
  }).join('');
}

const findOldestSubscription = (subscriptions) => {

  if (subscriptions.length) {
    // Convert the created_at dates to Date objects and find the oldest subscription
    const oldestSubscription = subscriptions.reduce((oldest, current) => {
      const oldestDate = new Date(oldest.created_at);
      const currentDate = new Date(current.created_at);
      return oldestDate < currentDate ? oldest : current;
    });

    return oldestSubscription;
  } else return false;

}


const autoLoginShopify = async () => {
  const mutlipassUrl = getOrderUrlByMultipass('/account');
  const response = await fetch(mutlipassUrl)
  const $loginButton = $('.thb-secondary-myaccount');
  $loginButton.attr('href', mutlipassUrl);
  $loginButton.text('My Account');
}

/**
 *  Get Order Url By multipass
 * @param redirectTo  String
 * @returns  {Promise<string>}
 */
const getOrderUrlByMultipass = (redirectTo) => {
  // Get Email or current user
  let email = ReCharge.customer.email;
  // Initialize mutlipass class
  let multipass = new ShopifyMultipass(globalStrings.multipassToken);
  // Prepare customeData html 
  let customerData = { email: email, return_to: redirectTo };
  // Get mutlipass url 
  let multipass_url = multipass.generateUrl(customerData);
  return multipass_url;
}


const initSlidingBorderEffect = () => {
  var $navContainer = $("#custom-navigation-dropdown");
  var $tabs = $(".tabsCustom label");
  var $slider = $(".slider");

  // Initial placement on checked tab
  var $checkedTab = $(".tabsCustom input:checked").parent();
  if ($checkedTab.length) {
    updateSlider($checkedTab, $navContainer, $slider);
  }

  // // Update slider on tab click
  // $tabs.on("click", function () {
  //   updateSlider($(this), $navContainer, $slider);
  //   const selectedNavigation = $(this).attr('data-path')
  //   handleAfterchangeCustomNavigationSelector(selectedNavigation)
  // });
};

const handleAfterchangeCustomNavigationSelector = (selectedNavigation) => {
  if (selectedNavigation === 'recharge-internal-logout') {
    window.location.href = '/account/logout';
  } else if (selectedNavigation === 'recharge-internal-address-order-history') {
    window.location.href = '/account?view=orders'
  } else if (selectedNavigation === 'recharge-internal-manage-subscriptions') {
    $(`a[data-testid="${selectedNavigation}"] > div > div`).click();
  } else {
    $(`a[data-testid="${selectedNavigation}"] > div > div`).click();
  }
}


function updateSlider($target, $navContainer, $slider) {
  $('.tabsCustom').removeClass('active')
  $target.parent().addClass('active');

  var leftPos = $target.position().left + $navContainer.scrollLeft();
  var width = $target.outerWidth();
  // Scroll the container to ensure the active item is visible
  $navContainer.animate({
    scrollLeft: leftPos - ($navContainer.width() / 2) + (width / 2)
  }, 300);
}

/**
 * Updates the order history menu in the UI with the latest content fetched asynchronously.
 * This function fetches the HTML content of the order history menu asynchronously using the getOrderHistoryMenuHtml function,
 * replaces the existing menu in the DOM with the fetched content, and ensures that the relevant UI element is visible.
 * 
 * @returns {void}
 */
const handleOrderHistoryMenu = async () => {
  try {
    // Fetch the order history menu HTML content asynchronously
    const orderHistoryMenu = await getOrderHistoryMenuHtml()

    // Replace the HTML content of the parent element of the anchor element with a specific data-testid attribute
    $('a[data-testid="recharge-internal-view-previous-orders"]').parent().html(orderHistoryMenu);

    // Show the anchor element with a specific data-testid attribute
    $('a[data-testid="recharge-internal-view-previous-orders"]').show();
  } catch (error) {
    // Handle any errors that occur during the process
    console.error('Error updating order history menu:', error);
    // Optionally, perform error handling such as displaying a user-friendly message
    // or logging the error for further investigation
  }
}


/**
 *  Get order history menu html
 * @returns  {Promise<string>}
 */
const getOrderHistoryMenuHtml = async () => {
  // const mutlipassUrl = getOrderUrlByMultipass('/account?view=orders');
  const mutlipassUrl = '/account?view=orders';

  // return html
  return `
  <a
  data-testid="recharge-internal-address-order-history"
  data-active="true"
  class=""
  id="customOrderHistoryMenuButton"
  href="${mutlipassUrl}"
>
  <div class="">
    <div class="recharge-card sideBarMenuLink">
      <div class="sideBarMenuWrap">
        <span
          role="heading"
          aria-level="2"
          class="recharge-heading recharge-heading-h2 affinityLinkText"
          >Order History</span
        >
        <div class="" style="padding:0 6px;">
          <div class="rechargeColor">
            <div class="recharge-icon">
              <svg viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <path d="m1.5 15 7-7-7-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</a>`
}



const ReferralLinksHandlerClass = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const intervalId = setInterval(() => {
      if (window.sessionRecharge) {
        this.sessionRecharge = window.sessionRecharge;
        clearInterval(intervalId);
        this.handleReferralHtml();
      }
    }, 200);

    // Need to hide this if user not found
    $('.how-it-works-section .logged_out').parent().remove();
  }

  async handleReferralHtml() {
    try {
      const customer = await recharge.customer.getCustomer(this.sessionRecharge, {
        include: ['addresses', 'referral_info'],
      });

      const referral_info = customer.include.referral_info;

      if (referral_info) {
        this.appendChild(this.createReferralHtml(referral_info));
        this.attachCopyEvent();
      }
    } catch (error) {
      console.error('Error fetching customer referral info:', error);
    }
  }

  createReferralHtml(referral_info) {
    const referralUrl = referral_info.referral_url.url;

    const html = `
          <div class="input-container-for-copy">
              <span id="readonlySpan" contenteditable="true">
                  ${referralUrl}
              </span>
              <a id="copyButton">
                 <svg style="width:25px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                  </svg>

              </a>
          </div>
      `;
    const div = document.createElement('div');
    div.innerHTML = html;

    return div;
  }

  attachCopyEvent() {
    const copyButton = this.querySelector('#copyButton');
    const readonlySpan = this.querySelector('#readonlySpan');

    if (copyButton && readonlySpan) {
      copyButton.addEventListener('click', () => {
        // Use the document.execCommand('copy') for copying content
        const range = document.createRange();
        range.selectNodeContents(readonlySpan);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        document.querySelector('.how-it-works-section-logged-in #copyButton').innerHTML = `
              <span style="display:flex;color:green;align-items:center">
                  <svg style="width:25px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                  </svg>
                  Copied
              </span>
              `
      });
    }
  }
};


if (!theme.design_mode) {
  // Define the custom element
  window.customElements.define('referal-link-container', ReferralLinksHandlerClass);
}

